export default "__VITE_ASSET__DcYVFot0__"